import { IModuloForm, IModuloRegistro } from '../../modules/types/ModuloSisaf';
import httpClient from '../httpClient';

const API_BASE = '/api/modulos';

export const getAllModulos = async (): Promise<IModuloRegistro[]> => {
  try {
    const response = await httpClient.get(API_BASE);

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error('Erro ao obter lista de módulos: ' + error.message);
  }
};

export const getModuloById = async (
  id: string | number,
): Promise<IModuloRegistro> => {
  try {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter Módulo: ' + error.message);
  }
};

export const handleCreateModulo = async (form: IModuloForm): Promise<any> => {
  try {
    const response = await httpClient.post(API_BASE, form);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao criar Módulo: ' + error.message);
  }
};

export const handleUpdateModulo = async (form: IModuloForm): Promise<any> => {
  try {
    const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao atualizar Módulo: ' + error.message);
  }
};

export const handleDeleteModulo = async (id: string | number): Promise<any> => {
  try {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao excluir Módulo: ' + error.message);
  }
};
